<template>
  <div
    :class="[$.select, $.group_by]"
  >
    <div v-if="isBoardConfigLoading">
      <skeleton-item
        type="bar"
        :style="{ height: '24px', width: '116px', marginRight: 0 }"
      />
    </div>
    <div
      v-else
      :class="[
        $.picker,
        isContextOpened ? $.active : ''
      ]"
      @click="({ currentTarget }) => toggleContextMenu(currentTarget)"
    >
      <div
        :class="$.label"
      >
        {{ label }}
      </div>
      <div
        :class="$.active"
      >
        {{ groupingName }}
      </div>
      <svg-sprite
        :name="isContextOpened ? 'arrow-top' : 'arrow-down'"
        :size="20"
      />
    </div>
  </div>
</template>

<script>
import SkeletonItem from '../../common/VueComponents/skeletons/skeletonItem.vue';

export default {
  name: 'BoardGrouping',
  components: {
    SkeletonItem
  },
  computed: {
    isBoardConfigLoading() {
      return this.$store.getters['board/isLoading'];
    },
    contextMenus() {
      return this.$store.getters['board/contextMenus'];
    },
    items() {
      return this.$store.getters['board/groupingFields'];
    },
    activeGrouping() {
      return this.items.find(item => item.isGroupedBy);
    },
    groupingName() {
      if (!this.activeGrouping) return '';

      return this.activeGrouping.value;
    },
    isContextOpened() {
      return this.contextMenus.some((context) => context.type === 'group');
    },
    label() {
      return __('board_group_by') + (this.sortName ? ': ' : ' ');
    }
  },
  methods: {
    toggleContextMenu(target = null) {
      this.$store.dispatch('board/setContextMenu', {
        item: {
          id: 'board_group_by'
        },
        type: 'group',
        menu: 'main',
        position: target?.getBoundingClientRect() || null,
        side: ''
      });
    },
  },
};
</script>

<style module="$" src="../less/select.less"></style>
